var _circle, _path, _path2, _path3, _ellipse, _ellipse2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup500(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#FEDC74"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 30.9385C13.6952 34.329 18.5388 37.4773 25.0776 33.8446",
    stroke: "#B4643A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3281 30.9385C46.6329 34.329 41.7893 37.4773 35.2506 33.8446",
    stroke: "#B4643A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23 47C23.8485 47.673 26.4364 48.6826 30 47.3365C33.5636 48.6826 36.1515 47.673 37 47",
    stroke: "#B4643A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 11,
    cy: 38,
    rx: 4,
    ry: 2,
    fill: "#FF9C8E"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 48.5,
    cy: 38,
    rx: 4.5,
    ry: 2,
    fill: "#FF9C8E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup500);
export default __webpack_public_path__ + "static/media/Group 500.203f0abdc5f1eaecc38f733268b4873f.svg";
export { ForwardRef as ReactComponent };